<script lang="ts">
  import Main from "../../organisms/recruitments/List.svelte";
  import Search from "../../organisms/recruitments/Search.svelte";
  import { RecruitmentService } from "../../services/recruitment.service";

  const name = "recruitment";
  const service = new RecruitmentService(name);
</script>

<div class="flex flex-col limit-screen">
  <Search {service} />
  <Main {service} klass="mt-4 overflow-y-scroll" />
</div>
